import { getCookie, setCookie } from '@calm/web-common/dist/cookies';
import isSSR from '@calm/web-common/dist/isSSR';
import { Environment } from '@rhg/constants';
import { useMemo } from 'react';

export const ANALYTICS_TOOLTIPS = 'analytics-tooltips';

/**
 * Enables analytics tooltips for 2 hours
 */
export function enableAnalyticsTitles() {
    if (!isSSR()) {
        setCookie(ANALYTICS_TOOLTIPS, 'true', 2 * 60);
    }
}

export function isAnalyticsTitlesEnabled() {
    return !isSSR() && getCookie(ANALYTICS_TOOLTIPS);
}

export function disableAnalyticsTooltips() {
    return !isSSR() && setCookie(ANALYTICS_TOOLTIPS, 'true', -1); // expire the cookie
}

export function useAnalyticsTitle(title: string) {
    const analyticsTitleProps = useMemo(() => {
        if (
            process.env.NEXT_PUBLIC_ENV !== Environment.PRODUCTION &&
            isAnalyticsTitlesEnabled()
        ) {
            return { title };
        }
        return {};
    }, [title]);

    return {
        analyticsTitleProps,
    };
}
